export const formatCurrency = (value) => {
  if (value === null || value === undefined) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const getCategoryIcon = (category) => {
  const icons = {
    art: 'Palette',
    wine: 'Wine',
    car: 'Car',
    jewelry: 'Gem',
    handbag: 'ShoppingBag',
    watch: 'Watch',
  };
  return icons[category] || 'Package';
};

export const getCategoryColor = (category) => {
  const colors = {
    art: 'text-purple-400',
    wine: 'text-red-400',
    car: 'text-emerald-400',
    jewelry: 'text-yellow-400',
    handbag: 'text-orange-400',
    watch: 'text-cyan-400',
  };
  return colors[category] || 'text-gray-400';
};

export const getCategoryImage = (category) => {
  const images = {
    car: 'https://images.unsplash.com/photo-1652727743972-5fd1483a23ab',
    art: 'https://images.unsplash.com/photo-1551619276-f77b2c749711',
    wine: 'https://images.unsplash.com/photo-1562663729-4971d6802f4a',
    jewelry: 'https://images.unsplash.com/photo-1631560230221-faff391fd241',
    handbag: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3',
    watch: 'https://images.unsplash.com/photo-1670404160620-a3a86428560e',
  };
  return images[category] || images.art;
};

export const ASSET_CATEGORIES = [
  { value: 'car', label: 'Cars', icon: 'Car' },
  { value: 'art', label: 'Fine Art', icon: 'Palette' },
  { value: 'wine', label: 'Wine & Spirits', icon: 'Wine' },
  { value: 'jewelry', label: 'Jewellery', icon: 'Gem' },
  { value: 'handbag', label: 'Handbags', icon: 'ShoppingBag' },
  { value: 'watch', label: 'Watches', icon: 'Watch' },
];
